
import { defineComponent } from 'vue';
import { Router } from 'vue-router';
import ManagementFrame from '@/components/ui/managementFrame/index.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import '@/assets/icons/back.svg';
import '@/assets/icons/add.svg';
import backToTeacherHome from '@/lib/backToTeacherHome';
import { Button, Pagination, Table } from 'ant-design-vue';
import Modal from '@/components/Modal.vue';
import asynButtonVue from '@/components/asynButton.vue';
import { CaseAnalysis, CaseAnalysisController } from './js/caseAnalysis';
import { JobView, JobViewController } from './js/jobView';
import EventDispatcher from './js/eventDispatcher';
import DisModal from './modal/distribution.vue';

export default defineComponent({
  name: 'CaseAnalysis',
  methods: {
    backToTeacherHome: (r: Router) => backToTeacherHome(r),
  },
  components: {
    Modal,
    SvgIcon,
    ManagementFrame,
    aPagination: Pagination,
    aTable: Table,
    aButton: asynButtonVue,
    DisModal,
  },
  setup() {
    const jobView = new JobView();
    const jobViewController = new JobViewController(jobView);
    const caseAnalysis = new CaseAnalysis();
    const caseAnalysisController = new CaseAnalysisController(caseAnalysis);
    const eventDispatcher = new EventDispatcher(caseAnalysis, jobView);
    return {
      jobView,
      jobViewController,
      caseAnalysis,
      caseAnalysisController,
      eventDispatcher,
      // methord

    };
  },
});
